import { Endpoint } from '../endpoint';

export const ElementVersionHistory = new Endpoint('element_version_history');
